/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/AdditionalFields/Content/Options",
  onChange,
  isInvalid
  
}) {
let questionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'type',
format: fromHelpers.isDisabled,
})
let questionOptionsValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'options',
})
let questionOptionsIsValidData = fromData.useDataIsValid({ viewPath,
context: 'question',
path: 'options',
validate: fromValidate.textInput,
})
let questionOptionsChangeData = fromData.useDataChange({ viewPath,
context: 'question',
path: 'options',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceM}
 maxWidth={320}
 data="question.type"
 format="helpers.js isDisabled"
 disabled={questionTypeValueData}
 data="question.options"
 validate="/Data/validate.js textInput"
 onChange={questionOptionsChangeData}
 value={questionOptionsValueData}
 invalid={!questionOptionsIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Options (type values separated by comma)"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}